import { Form } from 'antd';
import type { KeyboardEvent } from 'react';
import type { AppFormProps } from './Form.types';
import { getClassNames } from './Form.utils';
import { formValidateMessages } from './config/validate-messages';

export const AppForm = (props: AppFormProps) => {
  const { className, children, ...rest } = props;
  const classNames = getClassNames(className);

  const onKeyDown = (e: KeyboardEvent<HTMLFormElement>) => {
    if (e.key === 'Enter') {
      props.onSubmit?.();
    }
  };

  return (
    <Form
      layout="vertical"
      onKeyDown={onKeyDown}
      {...rest}
      className={classNames}
      validateMessages={formValidateMessages}
    >
      {children}
    </Form>
  );
};
